import { Component, OnInit } from '@angular/core';
import {PatientService} from '../service/patient.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientServiceService} from '../../client/client-service/client-service.service';
import {first} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-patient-view',
  templateUrl: './patient-view.component.html',
  styleUrls: ['./patient-view.component.css']
})
export class PatientViewComponent implements OnInit {

    itemsPerPage = 10;
    currentPage = 1;
    public numberOfPatients: any;
    regExp = '';
    loading: boolean;
    client: any;
    clientId: any;
    patientList: any [];
    patientStatusList: any = [
        { id: '1', value: 'ACTIVE' },
        { id: '2', value: 'BLOCKED' },
        { id: '3', value: 'NEW' }
    ];

    constructor(private patientService: PatientService, private clientService: ClientServiceService,
     private toastr: ToastrService, private router: Router) {
        this.clientId = localStorage.getItem('clientId');
        //this.client=this.getClientDetails(this.clientId);
    }

  ngOnInit() {
    this.getAllPatients();
  }

    public getClientDetails(clientId: any) {
        this.clientService.getClientById(clientId)
            .pipe(first())
            .subscribe(data => {
              console.log('client ::' + data.json())
              this.client = data.json();
            }, (error) => {
              this.toastr.error('', 'Please try again');
            });
    }

    getAllPatientsByStatus(status){
        this.loading = true;
        this.patientService.getAllPatients(this.currentPage - 1, status, this.itemsPerPage,'')
        .subscribe(data => {
          const response: any = data.json();
          this.patientList = response.patients;
          this.numberOfPatients = response.numberOfPatients;
          console.log(response.clients);

          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });

    }

   search() {
      console.log('' + this.regExp);
      this.getAllPatients();
    }


  public getAllPatients() {
    this.loading = true;
    this.patientService.getAllPatients(this.currentPage - 1, '', this.itemsPerPage,this.regExp)
        .subscribe(data => {
          const response: any = data.json();
          this.patientList = response.patients;
          this.numberOfPatients = response.numberOfPatients;
          console.log(response.clients);

          this.loading = false;
          // TODO - Uncomment below code when using actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

    onChangeStatusFilter(patientStatus) {
        console.log(patientStatus);

        if (patientStatus === 'ALL') {
            this.getAllPatients();
        } else {
            this.getAllPatientsByStatus(patientStatus);
        }
    }

    /*addCampaignForm(pId) {
        this.router.navigate( [ '/elasticcare/add/campaign' ], { fragment: pId } );
    }

    viewCampaign(mrn) {
        this.router.navigate( [ '/elasticcare/campaign' , {mrnParam: mrn}]);

    }*/

    pageChanged(event) {
        this.currentPage = event;
        this.getAllPatients();
        console.log(event);
    }
}
